export const RUNNER_DOM = {
  root: 'runner-ui',
  pauseRoot: 'runner-pause',
  pauseTitle: 'runner-pause-title',
  gameOverRoot: 'runner-gameover',
  stageSelectRoot: 'runner-stage-select',
} as const;
